import React, { useState, useEffect } from 'react';
import { fetchSaleReturns, saveSaleReturn, deleteSaleReturn, fetchSales, fetchCustomers } from '../../services/api';

const initialReturns = [
  { id: 1, date: '04-12-2025', returnNo: 'SR-0021', origBill: 'SL-2411', customer: 'Ravi Transport Co.', product: 'HSD', returnQty: 20,  rate: 96.52,  amount: 1930.40,  reason: 'Quality Issue',   status: 'Approved' },
  { id: 2, date: '03-12-2025', returnNo: 'SR-0020', origBill: 'SL-2405', customer: 'Lakshmi Roadways',   product: 'MS',  returnQty: 10,  rate: 108.34, amount: 1083.40,  reason: 'Billing Error',   status: 'Approved' },
  { id: 3, date: '02-12-2025', returnNo: 'SR-0019', origBill: 'SL-2398', customer: 'Cash',               product: 'HSD', returnQty: 5,   rate: 96.52,  amount: 482.60,   reason: 'Excess Fill',     status: 'Pending'  },
  { id: 4, date: '01-12-2025', returnNo: 'SR-0018', origBill: 'SL-2390', customer: 'Sai Enterprises',    product: 'HSD', returnQty: 50,  rate: 96.52,  amount: 4826.00,  reason: 'Product Dispute', status: 'Rejected' },
];

export default function SaleReturn({ user }) {
  const companyId = user?.Companyid || user?.company_id || "1";

  const [returns, setReturns] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ date: getTodayForUI(), origBill: '', customer_id: '', product: 'HSD', returnQty: '', rate: '', reason: '', status: 'Pending' });

  useEffect(() => {
    loadInitialData();
    loadData();
  }, [companyId]);

  function getTodayForUI() {
    const d = new Date();
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }

  function formatDateForAPI(dateStr) {
    if (!dateStr || !dateStr.includes('-')) return dateStr;
    const [y, m, d] = dateStr.split('-');
    return `${d}-${m}-${y}`;
  }

  const loadInitialData = async () => {
    try {
      const res = await fetchCustomers(companyId);
      if (res.success) setCustomers(res.Response || []);
    } catch (err) {
      console.error("Customers fetch error:", err);
    }
  };

  const loadData = async () => {
    setLoading(true);
    try {
      const res = await fetchSaleReturns({ Companyid: companyId });
      if (res.success) {
        const raw = res.Response || [];
        const list = Array.isArray(raw) ? raw : [raw];
        setReturns(list.map(r => ({
          id: r.IDS || r.Recid,
          date: r.Date1 || r.date,
          returnNo: r.ReturnNo || r.returnNo,
          origBill: r.OrigBill || r.origBill,
          customer: r.Customer || r.customer || '—',
          product: r.Product || r.product,
          returnQty: parseFloat(r.Qty || r.qty || 0),
          rate: parseFloat(r.Rate || r.rate || 0),
          amount: parseFloat(r.Amount || r.amount || 0),
          reason: r.Reason || r.reason || '—',
          status: r.Status || r.status || 'Pending'
        })));
      }
    } catch (err) {
      console.error("Returns fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    if (!form.origBill || !form.returnQty) return;
    
    try {
      const customer = customers.find(c => (c.Customerid || c.id) == form.customer_id);
      const payload = {
        Companyid: companyId,
        Date1: formatDateForAPI(form.date),
        OrigBill: form.origBill,
        Customerid: form.customer_id || "0",
        Name: customer ? (customer.Name || customer.name) : "Cash",
        Product: form.product,
        Qty: form.returnQty.toString(),
        Rate: form.rate.toString(),
        Amount: (parseFloat(form.returnQty) * parseFloat(form.rate)).toString(),
        Reason: form.reason,
        Status: "Pending",
        IDS: "0"
      };

      const result = await saveSaleReturn(payload);
      if (result.success || result.Response === "INSERTED") {
        await loadData();
        setShowForm(false);
        setForm({ date: getTodayForUI(), origBill: '', customer_id: '', product: 'HSD', returnQty: '', rate: '', reason: '', status: 'Pending' });
      } else {
        alert(result.message || "Failed to save return");
      }
    } catch (err) {
      console.error("Save error:", err);
    }
  };

  const updateStatus = async (id, status) => {
     // Usually an update endpoint
     alert("Status update logic would go here.");
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this record?')) return;
    try {
      const result = await deleteSaleReturn(id);
      if (result.success || result.Response === "DELETED" || result.status === "Success") {
        await loadData();
      } else {
        alert(result.message || "Failed to delete record");
      }
    } catch (err) {
      console.error("Delete error:", err);
    }
  };

  const total = returns.reduce((s, r) => s + r.amount, 0);
  const pending = returns.filter(r => r.status === 'Pending').length;

  return (
    <div className="pump-page">
      <div className="page-header">
        <h2 className="page-title">Sale Return</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="btn btn-primary btn-sm" onClick={() => setShowForm(!showForm)}>＋ New Return</button>
          <button className="export-btn">⬆ Export</button>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(155px,1fr))', gap: 12, marginBottom: 14 }}>
        {[
          { label: 'Total Returns', val: returns.length, color: 'var(--primary)' },
          { label: 'Pending Approval', val: pending, color: 'var(--warning)' },
          { label: 'Approved', val: returns.filter(r => r.status === 'Approved').length, color: 'var(--secondary)' },
          { label: 'Return Value', val: '₹' + total.toFixed(0), color: 'var(--danger)' },
        ].map(c => (
          <div key={c.label} style={{ background: '#fff', border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: '12px 16px', boxShadow: 'var(--shadow-sm)', borderLeft: `4px solid ${c.color}` }}>
            <div style={{ fontSize: 20, fontWeight: 800, color: c.color }}>{c.val}</div>
            <div style={{ fontSize: 11.5, color: 'var(--text-secondary)', fontWeight: 600 }}>{c.label}</div>
          </div>
        ))}
      </div>

      {showForm && (
        <div className="section-card">
          <div className="section-header">New Sale Return</div>
          <div className="form-row">
            <div className="form-group"><label>Date</label><input className="form-control" value={form.date} onChange={e => setForm({ ...form, date: e.target.value })} /></div>
            <div className="form-group"><label>Original Bill No.</label><input className="form-control" value={form.origBill} onChange={e => setForm({ ...form, origBill: e.target.value })} placeholder="SL-XXXX" /></div>
            <div className="form-group">
              <label>Customer</label>
              <select className="form-control" value={form.customer_id} onChange={e => setForm({ ...form, customer_id: e.target.value })}>
                <option value="">Cash</option>
                {customers.map(c => <option key={c.Customerid || c.id} value={c.Customerid || c.id}>{c.Name || c.name}</option>)}
              </select>
            </div>
            <div className="form-group"><label>Product</label><select className="form-control" value={form.product} onChange={e => setForm({ ...form, product: e.target.value })}><option>HSD</option><option>MS</option><option>CNG</option></select></div>
            <div className="form-group"><label>Return Qty (L)</label><input type="number" className="form-control" value={form.returnQty} onChange={e => setForm({ ...form, returnQty: e.target.value })} /></div>
            <div className="form-group"><label>Rate (₹)</label><input type="number" className="form-control" value={form.rate} onChange={e => setForm({ ...form, rate: e.target.value })} /></div>
            {form.returnQty && (
              <div className="form-group balance-group">
                <label>Return Amount</label>
                <div className="balance-value">₹{(+form.returnQty * +form.rate).toFixed(2)}</div>
              </div>
            )}
            <div className="form-group"><label>Reason</label><input className="form-control" value={form.reason} onChange={e => setForm({ ...form, reason: e.target.value })} placeholder="Quality Issue / Billing Error..." /></div>
          </div>
          <div className="action-bar" style={{ padding: '0 16px 14px' }}>
  <button className="btn btn-primary" onClick={handleSave}>
    <i className="bi bi-save me-1"></i> Save
  </button>

  <button className="btn btn-secondary" onClick={() => setShowForm(false)}>
    <i className="bi bi-x-lg me-1"></i> Cancel
  </button>
</div>
        </div>
      )}

      <div className="section-card">
        <div className="section-header">Sale Return Records — ₹{total.toLocaleString()}</div>
        <div className="table-wrapper">
          <table className="data-table">
            <thead><tr>
              
              <th style={{ textAlign: 'left' }}>Date</th>
              <th style={{ textAlign: 'left' }}>Return No.</th>
              <th style={{ textAlign: 'left' }}>Orig. Bill</th>
              <th style={{ textAlign: 'left' }}>Customer</th>
              <th style={{ textAlign: 'left' }}>Product</th>
              <th>Qty (L)</th>
              <th>Rate (₹)</th>
              <th>Amount (₹)</th>
              <th style={{ textAlign: 'left' }}>Reason</th>
              <th style={{ textAlign: 'left' }}>Status</th>
              <th style={{ textAlign: 'left' }}>Action</th>
            </tr></thead>
            <tbody>
              {returns.map((r, i) => (
                <tr key={r.id}>
                  
                  <td>{r.date}</td>
                  <td style={{ fontWeight: 700, color: 'var(--danger)', fontFamily: 'monospace' }}>{r.returnNo}</td>
                  <td style={{ fontFamily: 'monospace', color: 'var(--primary)' }}>{r.origBill}</td>
                  <td>{r.customer}</td>
                  <td><span className={`badge ${r.product === 'MS' ? 'badge-danger' : r.product === 'CNG' ? 'badge-success' : 'badge-info'}`}>{r.product}</span></td>
                  <td className="right-align">{r.returnQty}</td>
                  <td className="right-align">₹{r.rate.toFixed(2)}</td>
                  <td className="right-align">₹{r.amount.toLocaleString()}</td>
                  <td style={{ fontSize: 11.5, color: 'var(--text-secondary)' }}>{r.reason}</td>
                  <td><span className={`badge ${r.status === 'Approved' ? 'badge-success' : r.status === 'Rejected' ? 'badge-danger' : 'badge-warning'}`}>{r.status}</span></td>
                  <td>
                    {r.status !== 'Pending' && <span style={{ color: 'var(--text-muted)', fontSize: 11 }}>Processed</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
